import React from 'react';

import { MODAL_PAGE_KINDS } from '../../components/ModalPageForms/constants';
import ModalPageContent from './ModalPageContent/ModalPageContent';

export default function CheckOutCredential() {
  return <ModalPageContent modalPageKind={MODAL_PAGE_KINDS.COC} />;
}
